import { Card, Group, Text, ThemeIcon, Stack } from '@mantine/core';
import { type Icon } from '@tabler/icons-react';

interface StatCardProps {
  icon: Icon;
  label: string;
  value: string | number;
  color?: string;
  hint?: string;
  onClick?: () => void;
}

/** Qiymat boshidagi raqam ("1 394 444" — `formatSom` guruhlarni NBSP bilan ajratadi); qolgani — " so'm". */
const RAQAM = /^[−-]?\d(?:[\d\s]*\d)?/; // `\s` NBSP va tor NBSP ni ham qamraydi

/** Raqamning taxminiy kengligi, em (Manrope 800: raqam ≤ 0.674em, o'rtacha ~0.6; bo'shliq 0.2em) — zaxira bilan. */
function raqamEm(s: string): number {
  let em = 0;
  for (const ch of s) em += /\d/.test(ch) ? 0.64 : /\s/.test(ch) ? 0.22 : 0.56;
  return Math.max(em, 1);
}

/**
 * Ko'rsatkich kartasi. O'lchami KARTA kengligiga qarab (`index.css` → `.stat-karta`, container
 * query): raqam doim bitta qatorda va ikonka yonida sig'adigan shriftda; juda tor kartada ikonka
 * yashirinadi. Ilgari matn ustuni qisqarmasdi va uzun summa ikonkani karta chetidan itarib
 * chiqarar (karta `overflow: hidden` bilan ikkalasini qirqardi), yoki raqam o'rtasidan bo'linardi.
 */
export function StatCard({ icon: IconCmp, label, value, color = 'brand', hint, onClick }: StatCardProps) {
  const s = String(value);
  const son = RAQAM.exec(s)?.[0] ?? '';
  return (
    <Card
      onClick={onClick}
      style={onClick ? { cursor: 'pointer', transition: 'transform 120ms ease, box-shadow 120ms ease' } : undefined}
      className={onClick ? 'stat-karta sata-hoverable' : 'stat-karta'}
      padding="lg"
    >
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Stack gap={2} style={{ minWidth: 0 }}>
          <Text size="xs" c="dimmed" fw={600} tt="uppercase" style={{ letterSpacing: 0.3 }}>{label}</Text>
          <Text component="div" className="stat-qiymat" fw={800} lh={1.1} style={{ '--stat-em': raqamEm(son || s) } as React.CSSProperties}>
            {son && <span className="stat-son">{son}</span>}
            {s.slice(son.length)}
          </Text>
          {hint && <Text size="xs" c="dimmed">{hint}</Text>}
        </Stack>
        <ThemeIcon className="stat-ikonka" size={46} radius="md" variant="light" color={color} style={{ flexShrink: 0 }}>
          <IconCmp size={24} stroke={1.7} />
        </ThemeIcon>
      </Group>
    </Card>
  );
}
